import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const kes = new Intl.NumberFormat('en-KE', {
  style: 'currency',
  currency: 'KES',
  maximumFractionDigits: 0,
});

/** Matches the original `window.SH.money` formatter exactly. */
export function money(value: number) {
  return kes.format(value);
}

export function formatDate(value: string | Date, opts?: Intl.DateTimeFormatOptions) {
  const date = typeof value === 'string' ? new Date(value) : value;
  return date.toLocaleString('en-KE', opts ?? { dateStyle: 'medium', timeStyle: 'short' });
}

export function titleCase(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
